interface AppConfig {
  SERVER_API_URL: string;
  MANAGER_WEBSITE_BASE_URL: string;
  FRONTEND_WEBSITE_BASE_URL: string;
}

const appConfig: AppConfig = {
  SERVER_API_URL: "",
  MANAGER_WEBSITE_BASE_URL: "",
  FRONTEND_WEBSITE_BASE_URL: "",
};

export default appConfig;
